import React from "react";
import { Link } from "react-router-dom";
import { HOME_SECTION_BACKGROUND_URL } from "../constants/homeSectionBackground";
import { useTranslation } from "../i18n/useTranslation";

const CDN = "https://pub-dd11db53b680447d86c08d43682efe32.r2.dev";

const homeImage = (file: string) => `${CDN}/images/home/${encodeURIComponent(file)}`;

const StoryTypes: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section
      id="story-types"
      className="relative z-10 scroll-mt-20 overflow-hidden bg-brandBeige px-4 py-11 sm:px-6 sm:py-16"
      aria-labelledby="home-story-types-heading"
    >
      <img
        src={HOME_SECTION_BACKGROUND_URL}
        alt=""
        className="pointer-events-none absolute inset-0 h-full w-full object-cover object-center"
        aria-hidden
      />
      <div
        className="pointer-events-none absolute inset-0 bg-gradient-to-b from-white/35 via-white/10 to-brandBeige/25"
        aria-hidden
      />
      <div className="relative z-10 mx-auto max-w-5xl">
        <h2
          id="home-story-types-heading"
          className="mb-10 bg-gradient-to-r from-brandNavy via-brandOrange to-brandBlue bg-clip-text px-1 text-center text-[1.625rem] font-extrabold leading-tight text-transparent sm:mb-12 sm:text-3xl sm:px-0 md:text-4xl"
        >
          {t("home.storyTypesTitle")}
        </h2>
        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 sm:gap-8">
          <Link
            to="/create/language"
            className="group relative flex min-h-0 flex-col gap-4 overflow-hidden rounded-card border border-white/20 bg-gradient-to-br from-teal-600 via-[#3d8a96] to-brandNavy p-5 text-left text-white shadow-card transition hover:-translate-y-0.5 hover:shadow-glow focus:outline-none focus:ring-2 focus:ring-brandOrange focus:ring-offset-2 sm:min-h-[13rem] sm:p-8"
          >
            <div className="flex min-w-0 items-start justify-between gap-3">
              <h3 className="min-w-0 text-base font-extrabold leading-snug sm:text-lg md:text-xl">
                {t("home.storyTypesSurrogacyLabel")}
              </h3>
              <img
                src={homeImage("option1.png")}
                alt=""
                className="h-14 w-14 shrink-0 rounded-full object-cover opacity-90 drop-shadow-md sm:h-20 sm:w-20"
                width={80}
                height={80}
                aria-hidden
              />
            </div>
            <p className="mt-0 text-sm font-medium text-white/90 sm:mt-auto sm:text-base">
              {t("home.storyTypesSurrogacyBlurb")}
            </p>
            <span className="mt-3 text-xs font-semibold uppercase tracking-wider text-white/70 group-hover:text-white">
              {t("home.startYourBook")} →
            </span>
          </Link>

          <Link
            to="/create/language"
            className="group relative flex min-h-0 flex-col gap-4 overflow-hidden rounded-card border border-[#E07A52]/20 bg-gradient-to-br from-[#E07A52]/95 via-[#E8A090] to-amber-50 p-5 text-left text-heading shadow-card transition hover:-translate-y-0.5 hover:shadow-glow focus:outline-none focus:ring-2 focus:ring-brandOrange focus:ring-offset-2 sm:min-h-[13rem] sm:p-8"
          >
            <div className="flex min-w-0 items-start justify-between gap-3">
              <h3 className="min-w-0 text-base font-extrabold leading-snug sm:text-lg md:text-xl">
                {t("home.storyTypesGeneralLabel")}
              </h3>
              <img
                src={homeImage("option2.png")}
                alt=""
                className="h-14 w-14 shrink-0 rounded-full object-cover drop-shadow sm:h-20 sm:w-20"
                width={80}
                height={80}
                aria-hidden
              />
            </div>
            <p className="mt-0 text-sm font-medium text-heading/90 sm:mt-auto sm:text-base">
              {t("home.storyTypesGeneralBlurb")}
            </p>
            <span className="mt-3 text-xs font-semibold uppercase tracking-wider text-heading/60 group-hover:text-heading">
              {t("home.startYourBook")} →
            </span>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default StoryTypes;
